import { observer } from 'mobx-react';
import { FC, ReactElement, useCallback } from 'react';
import { DashboardDatePeriods, dashboardTabs } from '../../constants/dashboard';
import { dashboardStore } from '../../store/dashboardStore';
import Crumbs, { CrumbsType } from '~/view/components/Controls/Crumbs';

const DashboardFilterTabs: FC = observer((): ReactElement => {
  const onSelectCrumb = useCallback((value: DashboardDatePeriods) => {
    dashboardStore.updateFilters({ datePeriod: value });
  }, []);

  return (
    <Crumbs
      type={CrumbsType.TAB}
      crumbs={dashboardTabs}
      activeCrumb={dashboardStore.filters.datePeriod}
      onClick={onSelectCrumb}
      translateLabel
      wrapperClassName="mb-4"
    />
  );
});

export default DashboardFilterTabs;
